import * as MD from '@material-ui/core';
import { SvgIcon } from '@material-ui/core';
// ICONS
import AccountCircleIcon from '@material-ui/icons/AccountCircle';
import ExpandMore from '@material-ui/icons/ExpandMore';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import SearchIcon from '@material-ui/icons/Search';
import ToggleOffIcon from '@material-ui/icons/ToggleOff';
import ToggleOnIcon from '@material-ui/icons/ToggleOn';
import * as React from 'react';
import { connect } from 'react-redux';
import { RouteComponentProps } from 'react-router-dom';
import { Dispatch } from 'redux';
import { IApplicationState, IConnectedReduxProps } from '../Store';
//ACTIONS
import { setLocale } from '../Store/I18n/Actions';
import { Locales } from '../Store/I18n/Constants';
import { I18N, ILocaleInfos } from '../Store/I18n/Types';
import { hideDrawer, showDrawer, toggleTheme } from '../Store/Layout/Actions';
import { ILayoutState } from '../Store/Layout/Types';
import { logout } from '../Store/User/Actions';
import { IUserState } from '../Store/User/Types';
import { PaletteMode } from '../Themes';
import { YacastLogoIcon } from '../Themes/svg/yacast-logo';

interface IState {
	localeMenuAnchor: HTMLElement | null;
	localeMenuOpen: boolean;
	userMenuAnchor: HTMLElement | null;
	userMenuOpen: boolean;
	productMenuAnchor: HTMLElement | null;
	productMenuOpen: boolean;
}

interface IPropsFromState {
	i18n: I18N;
	layout: ILayoutState;
	localeInfos: ILocaleInfos;
	router: RouteComponentProps<{}>;
	user: IUserState;
	width: string;
}

interface IPropsFromDispatch {
	hideDrawer: typeof hideDrawer;
	logout: typeof logout;
	setLocale: typeof setLocale;
	showDrawer: typeof showDrawer;
	toggleTheme: typeof toggleTheme;
}
interface IPropsTheme {
	theme: any;
}

type AllProps = MD.WithStyles<typeof styles> &
	IPropsFromState &
	IPropsFromDispatch &
	RouteComponentProps<{}> &
	IPropsTheme &
	IConnectedReduxProps;

const initialState = {
	localeMenuAnchor: null,
	localeMenuOpen: false,
	userMenuAnchor: null,
	userMenuOpen: false,
	productMenuAnchor: null,
	productMenuOpen: false,
};

const styles = (theme: any) =>
	MD.createStyles({
		appBar: {
			left: theme.UserManagement.dimensions.drawerWidth,
			backgroundColor: theme.palette.background.default,
			height: theme.UserManagement.dimensions.appBarHeight,
			position: 'fixed',
			width: 'unset',
			zIndex: theme.zIndex.drawer - 1,
			'& >.MuiToolbar-regular': {
				minHeight: '50px',
			},
		},
		appBarFull: {
			left: 0,
			backgroundColor: theme.palette.background.default,
			height: theme.UserManagement.dimensions.appBarHeight,
			position: 'fixed',
			zIndex: theme.zIndex.drawer - 1,
			'& >.MuiToolbar-regular': {
				minHeight: '50px',
			},
		},
		barTitle: {
			color: 'inherit',
		},
		button: {},
		hamburger: {
			marginLeft: -12,
			marginRight: '-25px',
		},
		language: {
			marginLeft: 12,
			fontSize: '14px',
			color: theme.palette.text.primary,
		},
		logo: {
			width: '100%',
		},
		menuFlags: {
			marginRight: theme.spacing.toString(),
		},
		menuItems: {
			display: 'block',
			flexGrow: 1,
			'> span': {
				fontSize: '16px',
			},
		},
		menus: {
			display: 'flex',
			flexFlow: 'column',
			flexWrap: 'wrap',
		},
		myDeclarationsText: {
			fontSize: '12px',
		},
		logoStyle: {
			fontSize: 'x-large',
			textTransform: 'capitalize',
			marginLeft: '5px',
			marginRight: '15px',
			padding: '13px 24px',
			fontWeight: 500,
		},
		profileStyle: {
			padding: 0,
			color: theme.palette.text.primary,
		},
		tabItem: {
			'&:hover': {
				color: theme.palette.text.secondary,
			},
			color: theme.palette.text.primary,
			opacity: 0.7,
			transition: theme.transitions.create('color'),
			fontSize: '13px',
			minHeight: '38px',
		},
		tabItemIcon: {
			fontSize: '19px',
		},
		tabs: {
			marginLeft: 0,
			width: '100%',
			minHeight: '38px',
		},
		tabsIndicator: {
			background: 'none',
		},
		profileIcon: {
			fontSize: '19px',
		},
		searchButton: {
			paddingTop: '0px',
			paddingBottom: '0px',
			marginLeft: '10px',
		},
		switchTheme: {
			width: 0,
			top: 30,
			borderRadius: 7,
		},
	});

export class AppBarComponent extends React.Component<AllProps, IState> {
	public constructor(props: AllProps) {
		super(props);
		this.state = {
			...initialState,
		};
	}

	public render(): React.ReactNode {
		const { classes, theme } = this.props;

		let logoColor = '#FFFFFF';
		if (theme.palette.type === PaletteMode.LIGHT) {
			logoColor = theme.palette.text.primary;
		}
		return (
			<MD.AppBar
				className={
					this.props.layout.showDrawer
						? classes.appBar
						: classes.appBarFull
				}
			>
				<MD.Toolbar>
					{/* Hamburger */}
					<MD.IconButton
						className={classes.hamburger}
						onClick={this.toggleDrawer.bind(this)}
					>
						<MD.Icon color="primary">
							<MoreVertIcon />
						</MD.Icon>
					</MD.IconButton>
					{/* /Hamburger */}
					{/* Logo */}

					<MD.Box
						// aria-owns={open ? 'menu-locale' : undefined}
						className={classes.logoStyle}
						aria-haspopup="true"
						color="secondary"
						onClick={this.handleProductMenuOpen.bind(this) as any}
						// size='small'
					>
						<SvgIcon
							component={YacastLogoIcon}
							htmlColor={logoColor}
						/>
						{/* <img src={} alt="AdTrack" /> */}
					</MD.Box>

					{/* /Logo */}
					{/* Top links */}

					{this.props.user.groupID === 2
						? this.adminTopLink()
						: this.userTopLink()}

					{/* /Top links */}
					<p>{this.props.user.groupID === 2 ? 'Admin' : 'User'}</p>
					{/* Locale icon */}
					<MD.IconButton
						// aria-owns={open ? 'menu-locale' : undefined}
						className={classes.language}
						aria-haspopup="true"
						onClick={this.handleLocaleMenuOpen.bind(this) as any}
						size="small"
					>
						{this.props.localeInfos.name}
						<ExpandMore />
					</MD.IconButton>
					{/* /Locale icon */}
					{/* User icon */}
					<MD.IconButton
						aria-haspopup="true"
						className={classes.profileStyle}
						onClick={this.handleUserMenuOpen.bind(this) as any}
					>
						<AccountCircleIcon />
					</MD.IconButton>
					{/* /User icon */}
					{/* User menu */}
					<MD.Menu
						anchorEl={this.state.userMenuAnchor}
						anchorOrigin={{
							horizontal: 'right',
							vertical: 'top',
						}}
						className={classes.menus}
						id="menu-user"
						transformOrigin={{
							horizontal: 'left',
							vertical: 'bottom',
						}}
						onClose={this.handleMenuClose.bind(this) as any}
						open={this.state.userMenuOpen}
					>
						<MD.Button
							className={classes.menuItems}
							component="a"
							title={this.props.i18n._('My account')}
							variant="text"
						>
							{this.props.user.username}
						</MD.Button>

						<MD.Button
							className={classes.menuItems}
							component="a"
							onClick={this.handleLogout.bind(this) as any}
							title={this.props.i18n._('Log out my session')}
							variant="text"
						>
							{this.props.i18n._('Logout')}
						</MD.Button>

						<MD.Button
							className={classes.menuItems}
							component="a"
							onClick={
								this.handleChangePassword.bind(this) as any
							}
							title={this.props.i18n._('Change my password')}
							variant="text"
						>
							{this.props.i18n._('Change Password')}
						</MD.Button>
					</MD.Menu>
					{/* /User menu */}
					{/* Locale menu */}
					<MD.Menu
						anchorEl={this.state.localeMenuAnchor}
						anchorOrigin={{
							horizontal: 'right',
							vertical: 'top',
						}}
						className={classes.menus}
						id="menu-locale"
						transformOrigin={{
							horizontal: 'left',
							vertical: 'bottom',
						}}
						onClose={this.handleMenuClose.bind(this) as any}
						open={this.state.localeMenuOpen}
					>
						<MD.Button
							className={classes.menuItems}
							onClick={this.onLocaleChange.bind(
								this,
								Locales.French
							)}
							variant="text"
						>
							FR Passer en Français
						</MD.Button>
						<MD.Button
							className={classes.menuItems}
							onClick={this.onLocaleChange.bind(
								this,
								Locales.English
							)}
							variant="text"
						>
							GB Switch to english
						</MD.Button>
					</MD.Menu>
					{this.buildSwitchButton()}
					{/* /Locale menu */}
				</MD.Toolbar>
			</MD.AppBar>
		);
	}

	private pathPartitionning(pathParts: string[]): string {
		switch (pathParts.length > 1 ? pathParts[1] : '') {
			case 'apps':
				return `/${pathParts[1]}/${pathParts[2]}`;
			case 'ressources':
				return `/${pathParts[1]}/${pathParts[2]}`;
			case 'users':
				return `/${pathParts[1]}/${pathParts[2]}`;
			case 'home':
				return `/${pathParts[1]}`;
			default:
				return `/${pathParts[1]}`;
		}
	}

	private adminTopLink(): React.ReactNode {
		const { classes } = this.props;
		const currentPath = this.props.router.location.pathname;
		return (
			<MD.Tabs
				className={classes.tabs}
				onChange={this.onMenuTabChange.bind(this) as any}
				indicatorColor="primary"
				TabIndicatorProps={{ className: classes.tabsIndicator }}
				textColor="primary"
				value={currentPath}
			>
				{currentPath === '/users/groups' ? (
					<MD.Tab
						className={classes.tabItem}
						label={
							this.props.width === 'xs' ? (
								<SearchIcon className={classes.tabItemIcon} />
							) : (
								<MD.Grid alignItems="center" container>
									{this.props.i18n._('Users display')}
								</MD.Grid>
							)
						}
						value={'/users/groups'}
					/>
				) : currentPath === '/users/rights' ? (
					<MD.Tab
						className={classes.tabItem}
						label={
							this.props.width === 'xs' ? (
								<SearchIcon className={classes.tabItemIcon} />
							) : (
								<MD.Grid alignItems="center" container>
									{this.props.i18n._('Users display')}
								</MD.Grid>
							)
						}
						value={'/users/rights'}
					/>
				) : (
					<MD.Tab
						className={classes.tabItem}
						label={
							this.props.width === 'xs' ? (
								<SearchIcon className={classes.tabItemIcon} />
							) : (
								<MD.Grid alignItems="center" container>
									{this.props.i18n._('Users display')}
								</MD.Grid>
							)
						}
						value={'/users/users'}
					/>
				)}
				<MD.Tab
					className={classes.tabItem}
					label={
						this.props.width === 'xs' ? (
							<SearchIcon className={classes.tabItemIcon} />
						) : (
							<MD.Grid alignItems="center" container>
								{this.props.i18n._('User creation')}
							</MD.Grid>
						)
					}
					value={'/users/creation'}
				/>
				<MD.Tab
					className={classes.tabItem}
					label={
						this.props.width === 'xs' ? (
							<SearchIcon className={classes.tabItemIcon} />
						) : (
							<MD.Grid alignItems="center" container>
								{this.props.i18n._('Resource display')}
							</MD.Grid>
						)
					}
					value={'/ressources/ressources'}
				/>
				<MD.Tab
					className={classes.tabItem}
					label={
						this.props.width === 'xs' ? (
							<SearchIcon className={classes.tabItemIcon} />
						) : (
							<MD.Grid alignItems="center" container>
								{this.props.i18n._('Resource creation')}
							</MD.Grid>
						)
					}
					value={'/users/resource-creation'}
				/>
				{currentPath === '/users/modify' ? (
					<MD.Tab
						className={classes.tabItem}
						label={
							this.props.width === 'xs' ? (
								<SearchIcon className={classes.tabItemIcon} />
							) : (
								<MD.Grid alignItems="center" container>
									{this.props.i18n._('User Modification')}
								</MD.Grid>
							)
						}
						value={'/users/modify'}
					/>
				) : (
					''
				)}
				{this.maPath()}
			</MD.Tabs>
		);
	}

	private userTopLink(): React.ReactNode {
		const { classes } = this.props;
		const currentPath = this.props.router.location.pathname;
		return (
			<MD.Tabs
				className={classes.tabs}
				onChange={this.onMenuTabChange.bind(this) as any}
				indicatorColor="primary"
				TabIndicatorProps={{ className: classes.tabsIndicator }}
				textColor="primary"
				value={currentPath}
			>
				{currentPath === '/users/groups' ? (
					<MD.Tab
						className={classes.tabItem}
						label={
							this.props.width === 'xs' ? (
								<SearchIcon className={classes.tabItemIcon} />
							) : (
								<MD.Grid alignItems="center" container>
									{this.props.i18n._('Users display')}
								</MD.Grid>
							)
						}
						value={'/users/groups'}
					/>
				) : currentPath === '/users/rights' ? (
					<MD.Tab
						className={classes.tabItem}
						label={
							this.props.width === 'xs' ? (
								<SearchIcon className={classes.tabItemIcon} />
							) : (
								<MD.Grid alignItems="center" container>
									{this.props.i18n._('Users display')}
								</MD.Grid>
							)
						}
						value={'/users/rights'}
					/>
				) : (
					<MD.Tab
						className={classes.tabItem}
						label={
							this.props.width === 'xs' ? (
								<SearchIcon className={classes.tabItemIcon} />
							) : (
								<MD.Grid alignItems="center" container>
									{this.props.i18n._('Users display')}
								</MD.Grid>
							)
						}
						value={'/users/users'}
					/>
				)}

				<MD.Tab
					className={classes.tabItem}
					label={
						this.props.width === 'xs' ? (
							<SearchIcon className={classes.tabItemIcon} />
						) : (
							<MD.Grid alignItems="center" container>
								{this.props.i18n._('User creation')}
							</MD.Grid>
						)
					}
					value={'/users/creation'}
				/>
			</MD.Tabs>
		);
	}

	private maPath(): React.ReactNodeArray {
		const { classes } = this.props;
		const currentPath = this.props.router.location.pathname;
		const currentPath2 = this.pathPartitionning(currentPath.split('/'));
		switch (currentPath2) {
			case '/apps/mediaarchiver':
				return [
					<MD.Tab
						key={'/apps/channels'}
						className={classes.tabItem}
						label={
							this.props.width === 'xs' ? (
								<SearchIcon className={classes.tabItemIcon} />
							) : (
								<MD.Grid alignItems="center" container>
									{this.props.i18n._('Channels')}
								</MD.Grid>
							)
						}
						value={'/apps/channels'}
					/>,
					<MD.Tab
						key={currentPath2}
						className={classes.tabItem}
						label={
							this.props.width === 'xs' ? (
								<SearchIcon className={classes.tabItemIcon} />
							) : (
								<MD.Grid alignItems="center" container>
									{this.props.i18n._('Mediaarchiver Global')}
								</MD.Grid>
							)
						}
						value={currentPath2}
					/>,
				];
			case '/apps/mediaarchiver-user':
				return [
					<MD.Tab
						key={'/apps/channels'}
						className={classes.tabItem}
						label={
							this.props.width === 'xs' ? (
								<SearchIcon className={classes.tabItemIcon} />
							) : (
								<MD.Grid alignItems="center" container>
									{this.props.i18n._('Channels')}
								</MD.Grid>
							)
						}
						value={'/apps/channels'}
					/>,
					<MD.Tab
						key={currentPath2}
						className={classes.tabItem}
						label={
							this.props.width === 'xs' ? (
								<SearchIcon className={classes.tabItemIcon} />
							) : (
								<MD.Grid alignItems="center" container>
									{this.props.i18n._('Mediaarchiver - User')}
								</MD.Grid>
							)
						}
						value={currentPath2}
					/>,
				];
			case 'mediaarchiver-group':
				return [
					<MD.Tab
						key={'/apps/channels'}
						className={classes.tabItem}
						label={
							this.props.width === 'xs' ? (
								<SearchIcon className={classes.tabItemIcon} />
							) : (
								<MD.Grid alignItems="center" container>
									{this.props.i18n._('Channels')}
								</MD.Grid>
							)
						}
						value={'/apps/channels'}
					/>,
					<MD.Tab
						key={currentPath2}
						className={classes.tabItem}
						label={
							this.props.width === 'xs' ? (
								<SearchIcon className={classes.tabItemIcon} />
							) : (
								<MD.Grid alignItems="center" container>
									{this.props.i18n._('Mediaarchiver - Group')}
								</MD.Grid>
							)
						}
						value={currentPath2}
					/>,
				];
			case 'mediaarchiver-tpp':
				return [
					<MD.Tab
						key={'/apps/channels'}
						className={classes.tabItem}
						label={
							this.props.width === 'xs' ? (
								<SearchIcon className={classes.tabItemIcon} />
							) : (
								<MD.Grid alignItems="center" container>
									{this.props.i18n._('Channels')}
								</MD.Grid>
							)
						}
						value={'/apps/channels'}
					/>,
					<MD.Tab
						key={currentPath2}
						className={classes.tabItem}
						label={
							this.props.width === 'xs' ? (
								<SearchIcon className={classes.tabItemIcon} />
							) : (
								<MD.Grid alignItems="center" container>
									{this.props.i18n._('Mediaarchiver - TPP')}
								</MD.Grid>
							)
						}
						value={currentPath2}
					/>,
				];
			case 'mediaarchiver-tpp-user':
				return [
					<MD.Tab
						key={'/apps/channels'}
						className={classes.tabItem}
						label={
							this.props.width === 'xs' ? (
								<SearchIcon className={classes.tabItemIcon} />
							) : (
								<MD.Grid alignItems="center" container>
									{this.props.i18n._('Channels')}
								</MD.Grid>
							)
						}
						value={'/apps/channels'}
					/>,
					<MD.Tab
						key={currentPath2}
						className={classes.tabItem}
						label={
							this.props.width === 'xs' ? (
								<SearchIcon className={classes.tabItemIcon} />
							) : (
								<MD.Grid alignItems="center" container>
									{this.props.i18n._(
										'Mediaarchiver - TPP - User'
									)}
								</MD.Grid>
							)
						}
						value={currentPath2}
					/>,
				];
			case 'mediaarchiver-tpp-group':
				return [
					<MD.Tab
						key={'/apps/channels'}
						className={classes.tabItem}
						label={
							this.props.width === 'xs' ? (
								<SearchIcon className={classes.tabItemIcon} />
							) : (
								<MD.Grid alignItems="center" container>
									{this.props.i18n._('Channels')}
								</MD.Grid>
							)
						}
						value={'/apps/channels'}
					/>,
					<MD.Tab
						key={currentPath2}
						className={classes.tabItem}
						label={
							this.props.width === 'xs' ? (
								<SearchIcon className={classes.tabItemIcon} />
							) : (
								<MD.Grid alignItems="center" container>
									{this.props.i18n._(
										'Mediaarchiver - TPP - Group'
									)}
								</MD.Grid>
							)
						}
						value={currentPath2}
					/>,
				];
			case 'mediaarchiver-stt':
				return [
					<MD.Tab
						key={'/apps/channels'}
						className={classes.tabItem}
						label={
							this.props.width === 'xs' ? (
								<SearchIcon className={classes.tabItemIcon} />
							) : (
								<MD.Grid alignItems="center" container>
									{this.props.i18n._('Channels')}
								</MD.Grid>
							)
						}
						value={'/apps/channels'}
					/>,
					<MD.Tab
						key={currentPath2}
						className={classes.tabItem}
						label={
							this.props.width === 'xs' ? (
								<SearchIcon className={classes.tabItemIcon} />
							) : (
								<MD.Grid alignItems="center" container>
									{this.props.i18n._('Mediaarchiver - STT')}
								</MD.Grid>
							)
						}
						value={currentPath2}
					/>,
				];
			case 'mytrack':
				return [
					<MD.Tab
						key={'/apps/channels'}
						className={classes.tabItem}
						label={
							this.props.width === 'xs' ? (
								<SearchIcon className={classes.tabItemIcon} />
							) : (
								<MD.Grid alignItems="center" container>
									{this.props.i18n._('Channels')}
								</MD.Grid>
							)
						}
						value={'/apps/channels'}
					/>,
					<MD.Tab
						key={currentPath2}
						className={classes.tabItem}
						label={
							this.props.width === 'xs' ? (
								<SearchIcon className={classes.tabItemIcon} />
							) : (
								<MD.Grid alignItems="center" container>
									{this.props.i18n._('Mytrack')}
								</MD.Grid>
							)
						}
						value={currentPath2}
					/>,
				];
			case 'mediaarchiver-stt-user':
				return [
					<MD.Tab
						key={'/apps/channels'}
						className={classes.tabItem}
						label={
							this.props.width === 'xs' ? (
								<SearchIcon className={classes.tabItemIcon} />
							) : (
								<MD.Grid alignItems="center" container>
									{this.props.i18n._('Channels')}
								</MD.Grid>
							)
						}
						value={'/apps/channels'}
					/>,
					<MD.Tab
						key={currentPath2}
						className={classes.tabItem}
						label={
							this.props.width === 'xs' ? (
								<SearchIcon className={classes.tabItemIcon} />
							) : (
								<MD.Grid alignItems="center" container>
									{this.props.i18n._(
										'Mediaarchiver - STT - User'
									)}
								</MD.Grid>
							)
						}
						value={currentPath2}
					/>,
				];
			case 'mediaarchiver-stt-group':
				return [
					<MD.Tab
						key={'/apps/channels'}
						className={classes.tabItem}
						label={
							this.props.width === 'xs' ? (
								<SearchIcon className={classes.tabItemIcon} />
							) : (
								<MD.Grid alignItems="center" container>
									{this.props.i18n._('Channels')}
								</MD.Grid>
							)
						}
						value={'/apps/channels'}
					/>,
					<MD.Tab
						key={currentPath2}
						className={classes.tabItem}
						label={
							this.props.width === 'xs' ? (
								<SearchIcon className={classes.tabItemIcon} />
							) : (
								<MD.Grid alignItems="center" container>
									{this.props.i18n._(
										'Mediaarchiver - STT - Group'
									)}
								</MD.Grid>
							)
						}
						value={currentPath2}
					/>,
				];

			case 'mytrack-group':
				return [
					<MD.Tab
						key={'/apps/channels'}
						className={classes.tabItem}
						label={
							this.props.width === 'xs' ? (
								<SearchIcon className={classes.tabItemIcon} />
							) : (
								<MD.Grid alignItems="center" container>
									{this.props.i18n._('Channels')}
								</MD.Grid>
							)
						}
						value={'/apps/channels'}
					/>,
					<MD.Tab
						key={currentPath2}
						className={classes.tabItem}
						label={
							this.props.width === 'xs' ? (
								<SearchIcon className={classes.tabItemIcon} />
							) : (
								<MD.Grid alignItems="center" container>
									{this.props.i18n._('Mytrack - Group')}
								</MD.Grid>
							)
						}
						value={currentPath2}
					/>,
				];
			default:
				return [
					<MD.Tab
						key={'/apps/channels'}
						className={classes.tabItem}
						label={
							this.props.width === 'xs' ? (
								<SearchIcon className={classes.tabItemIcon} />
							) : (
								<MD.Grid alignItems="center" container>
									{this.props.i18n._('Channels')}
								</MD.Grid>
							)
						}
						value={'/apps/channels'}
					/>,
				];
		}
	}

	private buildSwitchButton() {
		const { classes, theme, layout } = this.props;

		return (
			<MD.IconButton
				className={classes.switchTheme + classes.searchButton}
				style={{ margin: 0, padding: 0 }}
				onClick={this.props.toggleTheme}
			>
				{layout.theme === PaletteMode.DARK ? (
					<ToggleOnIcon
						style={{
							fill: theme.palette.secondary.main,
							fontSize: 'xxx-large',
						}}
					/>
				) : (
					<ToggleOffIcon style={{ fontSize: 'xxx-large' }} />
				)}
			</MD.IconButton>
		);
	}

	private handleUserMenuOpen(ev: MouseEvent) {
		ev.preventDefault();
		ev.stopPropagation();
		this.setState({
			userMenuAnchor: ev.target as HTMLElement,
			userMenuOpen: true,
		});
	}

	private handleLocaleMenuOpen(ev: MouseEvent) {
		ev.preventDefault();
		ev.stopPropagation();
		this.setState({
			localeMenuAnchor: ev.target as HTMLElement,
			localeMenuOpen: true,
		});
	}

	private handleMenuClose(ev: MouseEvent) {
		ev.preventDefault();
		ev.stopPropagation();
		this.setState({ ...initialState });
	}

	private handleProductMenuOpen(ev: MouseEvent) {
		ev.preventDefault();
		ev.stopPropagation();
		this.setState({
			productMenuAnchor: ev.target as HTMLElement,
			productMenuOpen: true,
		});
	}

	private onProductChange(product: string) {
		this.setState({
			...initialState,
		});
		if (product === 'mytrack') {
			window.open('http://192.168.12.102/', '_self');
		} else if (product === 'progtrack') {
			window.open('https://progtrack.yacast.fr/', '_self');
		} else if (product === 'righttrack') {
			window.open('https://righttrack.yacast.fr/', '_self');
		} else if (product === 'adtrack') {
			window.open('https://adtrack.yacast.fr/', '_self');
		} else if (product === 'speechtrack') {
			window.open('https://speechtrack.yacast.fr/', '_self');
		}
	}

	private handleLogout(ev: MouseEvent) {
		ev.preventDefault();
		ev.stopPropagation();
		this.props.logout();
	}

	private handleChangePassword(ev: MouseEvent) {
		ev.preventDefault();
		ev.stopPropagation();
		window.open(
			'/new_password?token=' +
				this.props.user.token +
				'&id=' +
				this.props.user.userInfo.id,
			'_blank'
		);
	}

	private onMenuTabChange(ev: MouseEvent, value: string) {
		ev.preventDefault();
		ev.stopPropagation();
		if (ev.target === null) {
			return;
		}
		if (value === '/users/rights') {
			this.props.history.push('/users/users');
			return;
		}
		this.props.history.push(value);
	}

	private toggleDrawer() {
		if (this.props.layout.showDrawer) {
			this.props.hideDrawer();
			return;
		}
		this.props.showDrawer();
	}

	private onLocaleChange(locale: Locales) {
		this.setState({
			...initialState,
		});
		this.props.setLocale(locale);
	}
}

const mapStateToProps = (
	{ i18n, layout, user }: IApplicationState,
	ownProps: RouteComponentProps<{}>
) => ({
	i18n: i18n.i18n,
	layout,
	localeInfos: i18n.localeInfos,
	router: ownProps,
	user,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
	hideDrawer: () => dispatch(hideDrawer()),
	logout: () => dispatch(logout()),
	setLocale: (locale: Locales) => dispatch(setLocale(locale)),
	showDrawer: () => dispatch(showDrawer()),
	toggleTheme: () => dispatch(toggleTheme()),
});

export const AppBar = connect(
	mapStateToProps,
	mapDispatchToProps
)(MD.withTheme(MD.withWidth()(MD.withStyles(styles)(AppBarComponent))));
